import React from 'react';

/** Conteneur de panneau réutilisable, avec en-tête (icône + titre + extra). */
export default function Panel({ icon: Icon, title, sub, badge, extra, children, delay = 0, className = '' }) {
  return (
    <section
      className={`panel reveal ${className}`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="panel__head">
        <div className="panel__title">
          {Icon && <span className="ic"><Icon /></span>}
          <div>
            <h3>{title}</h3>
            {sub && <div className="panel__sub">{sub}</div>}
          </div>
        </div>
        {badge && <span className="panel__badge">{badge}</span>}
        {extra}
      </div>
      <div className="panel__body">{children}</div>
    </section>
  );
}
